/** @jsxImportSource @emotion/react */
import { styled } from '@mui/material/styles';
import TableRow from '@mui/material/TableRow';

const StyledSideToSideTableRow = styled(TableRow)(() => ({
  display: 'flex',
  alignItems: 'center',
  fontSize: '0.5rem',
}))

export default StyledSideToSideTableRow;